import moment from 'moment'

/**
 * Parse the time to string
 * @param {(number)} time
 * @returns {string}
 */
export function formatDate(value) {
    if(!value){
        return '';
    }
    if(isNaN(new Date(value).getTime())){
        return '';
    }
    let date = new Date(value)
    let y = date.getFullYear()
    let MM = date.getMonth() + 1
    MM = MM < 10 ? ('0' + MM) : MM
    let d = date.getDate()
    d = d < 10 ? ('0' + d) : d
    let h = date.getHours()
    h = h < 10 ? ('0' + h) : h
    let m = date.getMinutes()
    m = m < 10 ? ('0' + m) : m
    let s = date.getSeconds()
    s = s < 10 ? ('0' + s) : s
    return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
        // return y + '-' + MM + '-' + d
}

export function formatDate2(value) {
    let date = new Date(value)
    let y = date.getFullYear()
    let MM = date.getMonth() + 1
    MM = MM < 10 ? ('0' + MM) : MM
    let d = date.getDate()
    d = d < 10 ? ('0' + d) : d
    let h = date.getHours()
    h = h < 10 ? ('0' + h) : h
    let m = date.getMinutes()
    m = m < 10 ? ('0' + m) : m
    let s = date.getSeconds()
    s = s < 10 ? ('0' + s) : s
    return y+'.'+MM+'.'+d
        // return y + '-' + MM + '-' + d
}

/**
 * deepClone=>
 * @param {(object)}
 * @returns {object}
 */

export function deepClone(obj) {
    var target = {};
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (typeof obj[key] === 'object') {
                target[key] = deepClone(obj[key]);
            } else {
                target[key] = obj[key];
            }
        }
    }
    return target;
}


/**
 * mobileFilter=>手机号中间隐藏
 * @param {(Number)}
 * @returns {String}
 */
export function mobileFilter(val) {
    if (val) {
        let reg = /^(.{3}).*(.{4})$/
        return val.replace(reg, '$1****$2') || '-'
    }

}

/**
 * codeFilter=>
 * @param {(Number)}
 * @returns {String}
 */
export function codeFilter(val) {
    console.log(val);
    if (val.length > 5) {
        let star = ''
        for (var i = 0; i < val.length - 2; i++) {
            star = star + '*'
        }
        return val.substring(0, 1) + star + val.substring(val.length - 1, val.length);
    }

}


/**
 * ArrayFiflter=>数组过滤
 * @param {(Array,Number)}
 * @returns {Array}
 */
export function group(array, subGroupLength) {
    let index = 0;
    let newArray = [];
    while (index < array.length) {
        newArray.push(array.slice(index, (index += subGroupLength)));
    }
    return newArray;
}

/**
 * nameFilter=>
 * @param {(Number||String)}
 * @returns {String}
 */
export function processName(str) {
    if (null != str && str != undefined) {
        let star = ''
        if (str.length <= 2) {
            return "*" + str.substring(1, 2);
        } else if (str.length === 3) {
            return "*" + str.substring(1, 3);
        } else {
            for (var i = 0; i < str.length - 2; i++) {
                star = '*' + star
            }
            return str.substring(0, 2) + star + str.substring(str.length - 2, str.length);
        }
    }
}

/**
 * UrlSearch=>
 * @param {(window.url)}
 * @returns {String||Number}
 */
export function GetUrlParam(paraName) {
    var url = document.location.toString();
    var arrObj = url.split("?");

    if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;

        for (var i = 0; i < arrPara.length; i++) {
            arr = arrPara[i].split("=");

            if (arr != null && arr[0] == paraName) {
                return arr[1];
            }
        }
        return "";
    } else {
        return "";
    }
}

//获取链接后面所有参数
export function GetRequest(url) {
    //var url = location.search; //获取url中"?"符后的字串  
    if (url.indexOf("?") == -1) {
        return false
    } else {
        let arrObj = url.split("?");
        let theRequest = new Object();
        let str = arrObj[1];
        let strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
        return theRequest;
    }

}

//删除给定对象中值为空的键值对
export function filterParams(obj) {
    var _newPar = {};
    for (var key in obj) {
        if ((obj[key] === 0 || obj[key] === false || obj[key]) && obj[key].toString().replace(/(^\s*)|(\s*$)/g, '') !== '') {
            _newPar[key] = obj[key];
        }
    }
    return _newPar;
}

//类型数字转文字
export function sourceType(typeNum) {
    switch (typeNum) {
        case 975260:
            return "用户中心";
            break;
        case 955210:
            return "时间戳";
            break;
        case 925220:
            return "壹签";
            break;
        case 955740:
            return "电子证据";
            break;
        case 955255:
            return "RA";
            break;
        case 995280:
            return "经销商前台";
            break;
        case 915290:
            return "经销商后台";
            break;
        case 952310:
            return "知识产权";
            break;
        case 954210:
            return "权利卫士";
            break;
        case 975281:
            return "维权平台";
            break;
        case 800001:
            return "天平阳光";
            break;
        case 801001:
            return "百度";
            break;
        case 700005:
            return "后台";
        case 700006:
            return "找律师";
            break;
        case 700023:
            return "软著保护平台";
            break;
        case 700025:
            return "邮件认证平台";
            break;
        case 999000:
            return "兑换码";
            break;
        case 700038:
            return "官网";
            break;
        case 700012:
            return "老官网";
            break;
        case 999000:
            return "兑换码";
            break;
        case 999001:
            return "优惠券";
            break;
        case 999111:
            return "活动";
            break;
        case 700021:
            return "代码确权";
            break;
        case 700011:
            return "验证平台";
            break;
        case 700025:
            return "邮件认证平台";
            break;
        case 700028:
            return "AIGC";
            break;
        case 700039:
            return "监测平台";
            break;
        case 700041:
            return "遗嘱卫士";
            break;
        case 700014:
            return "律协推广";
            break;
        case 800059:
            return "邀请有礼领现金";
            break;
        case 800060:
            return "邀请有礼";
            break;
        case 954211:
            return "公标胎记";
            break;
        case 700044:
            return "版权中心";
            break;
        case 952311:
            return "时间戳数据认证";
            break;
        case 700045:
            return "可信时间戳AI";
            break;
        case 700047:
            return "证据管理中心";
            break;
        case 700015:
            return "大学生知识产权保护计划";
            break;
        case 700048:
            return "律师培训";
            break;
        default:
            return '';
    }
}

export function payType(typeNum) {
    switch (typeNum) {
        case 0:
            return "未支付";
            break;
        case 1:
            return "支付宝";
            break;
        case 2:
            return "微信";
            break;
        case 3:
            return "银联";
            break;
        case 4:
            return "赠送";
            break;
        case 5:
            return "兑换码";
            break;
        case 9:
            return "--";
            break;
        case 127:
            return "--";
            break;
    }
}


//将给定数组，拆分成若干个数组的集合
export function splitArray(array, num) {
    let index = 0;
    let newArray = [];
    while (index < array.length) {
        newArray.push(array.slice(index, index += num));
    }
    return newArray;
}

//整理数组对象，账户概览页饼图专用
export function regroupData(array) {
    let newArray = [];
    let obj;
    for (let i = 0; i < array.length; i++) {
        obj = array[i];
        obj.name = array[i].sourceTypeName;
        obj.value = array[i].tsCount;
        newArray.push(obj);
    }
    return newArray
}

//计算数组对象中某个字段的总和，账户概览页饼图专用
export function numTotal(array) {
    let total = 0;
    for (let i = 0; i < array.length; i++) {
        total += array[i].tsCount;
    }
    return total
}

//根据时间戳计算时间差
export function diffTime(startDate, endDate) {
    var diff = endDate - startDate; //时间差的毫秒数 
    //计算出相差天数 
    var days = Math.floor(diff / (24 * 3600 * 1000));

    //计算出小时数 
    var leave1 = diff % (24 * 3600 * 1000); //计算天数后剩余的毫秒数 
    var hours = Math.floor(leave1 / (3600 * 1000));
    //计算相差分钟数 
    var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数 
    var minutes = Math.floor(leave2 / (60 * 1000));

    //计算相差秒数 
    var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数 
    var seconds = Math.round(leave3 / 1000);

    var returnStr = seconds + "秒";
    if (minutes > 0) {
        returnStr = minutes + "分" + returnStr;
    }
    if (hours > 0) {
        returnStr = hours + "小时" + returnStr;
    }
    if (days > 0) {
        returnStr = days + "天" + returnStr;
    }
    //console.log((days * 24 + hours) + '：' + minutes + '：' + seconds)
    let time = {
        days,
        hours,
        minutes,
        seconds
    }
    return time;
}

//根据给定年份和月份得到月份的开始时间和结束时间
export function getMonthDateRange(year, month) {
    // month in moment is 0 based, so 9 is actually october, subtract 1 to compensate
    // array is 'year', 'month', 'day', etc
    var startDate = moment([year, month - 1]);

    // Clone the value before .endOf()
    var endDate = moment(startDate).endOf('month');

    // just for demonstration:
    // console.log(startDate.toDate().valueOf());
    // console.log(endDate.toDate().valueOf());

    // make sure to call toDate() for plain JavaScript date type
    return { start: startDate.toDate().valueOf(), end: endDate.toDate().valueOf() };
}

//将base64转换为blob
export const dataURLtoBlob = (dataurl) => { 
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
}

//将blob转换为file
export const blobToFile = (theBlob, fileName) => {
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
}

//消费对象转NAME
export function businessTypeInfo(typeNum) {
    switch (typeNum) {
        case 955740:
            return "证据名称";
            break;
        case 954210:
            return "证据名称";
            break;
        case 952310:
            return "文件名称";
            break;
        case 700023:
            return "文件名称";
            break;
        case 700025:
            return "邮件主题名称";
            break;
    }
}

//将文件byte转对应大小
export function fileSize(value) {
    let size=value
    let num = 1024.00; //byte
    if (!size)
        return "";
    if (size < num)
        return size + "B";
    if (size < Math.pow(num, 2))
        return (size / num).toFixed(2) + "K"; //kb
    if (size < Math.pow(num, 3))
        return (size / Math.pow(num, 2)).toFixed(2) + "M"; //M
    if (size < Math.pow(num, 4))
        return (size / Math.pow(num, 3)).toFixed(2) + "G"; //G
    return (size / Math.pow(num, 4)).toFixed(2) + "T"; //T
}

//计算折扣
export function convertToDiscount(value) {
    // 输入校验
    if (typeof value !== 'number' || value < 0 || value > 1) {
        return '无效的输入';
    }

    // 计算百分比并向下取整到最近的5的倍数
    const percentage = Math.floor(value  * 100);
    const rounded = Math.floor(percentage  / 5) * 5;

    // 格式化输出
    return `${rounded / 10}`;
}

export function formatDate3(value) {
    let date = new Date(value)
    let y = date.getFullYear()
    let MM = date.getMonth() + 1
    MM = MM < 10 ? ('0' + MM) : MM
    let d = date.getDate()
    d = d < 10 ? ('0' + d) : d
    let h = date.getHours()
    h = h < 10 ? ('0' + h) : h
    let m = date.getMinutes()
    m = m < 10 ? ('0' + m) : m
    let s = date.getSeconds()
    s = s < 10 ? ('0' + s) : s
    // return y+'.'+MM+'.'+d
    return y + '-' + MM + '-' + d
}

//修改字符串
export function replaceStr(str,statrIndex,endIndex,replacement) {
    return str.toString().substring(0, statrIndex)+ replacement + str.toString().substring(endIndex);
}
